'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _pick = require('lodash/pick');var _pick2 = _interopRequireDefault(_pick);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _reactRouter = require('react-router');
var _cloneDeep = require('lodash/cloneDeep');var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _invariant = require('@turf/invariant');
var _reactScrollbarsCustom = require('react-scrollbars-custom');var _reactScrollbarsCustom2 = _interopRequireDefault(_reactScrollbarsCustom);

var _components = require('../../components');
var _containers = require('../../containers');




var _googleService = require('../../helpers/googleService');var _googleService2 = _interopRequireDefault(_googleService);

var _slugify = require('../../helpers/slugify');var _slugify2 = _interopRequireDefault(_slugify);
var _checkUserAgent = require('../../utils/checkUserAgent');var _checkUserAgent2 = _interopRequireDefault(_checkUserAgent);
var _constants = require('../../constants');







var _formatSEOData = require('../../utils/formatSEOData');



var _index = require('../../utils/seo/index');
var _formatObjectToQuery = require('../../utils/formatObjectToQuery');var _formatObjectToQuery2 = _interopRequireDefault(_formatObjectToQuery);
var _getLoadType = require('../../utils/getLoadType');var _getLoadType2 = _interopRequireDefault(_getLoadType);
var _routerAdapter = require('../../helpers/routerAdapter');
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');




var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);
var _services = require('../../services');
var _MapboxService = require('../../services/MapboxService/MapboxService');var _MapboxService2 = _interopRequireDefault(_MapboxService);
var _generateCanonicalLink = require('../../utils/generateCanonicalLink');var _generateCanonicalLink2 = _interopRequireDefault(_generateCanonicalLink);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _calculateMobileActiveFiltersQuantity = require('../../helpers/calculateMobileActiveFiltersQuantity');var _calculateMobileActiveFiltersQuantity2 = _interopRequireDefault(_calculateMobileActiveFiltersQuantity);

var _recentSearches = require('../../redux/modules/recentSearches');
var _propertyPins = require('../../redux/modules/propertyPins');
var _propertyDetails = require('../../redux/modules/propertyDetails');



var _propertySearch = require('../../redux/modules/propertySearch');









var _agencySearch = require('../../redux/modules/agencySearch');
var _saveSearchLocation = require('../../redux/modules/saveSearchLocation');




var _mobilesFilters = require('../../redux/modules/mobilesFilters');



var _advancedFilters = require('../../redux/modules/advancedFilters');



var _favoriteProperties = require('../../redux/modules/favoriteProperties');





var _propertyNotes = require('../../redux/modules/propertyNotes');
var _reviewedPins = require('../../redux/modules/reviewedPins');
var _userAuthentication = require('../../redux/modules/userAuthentication');





var _findByNeighborhood = require('../../redux/modules/findByNeighborhood');

var _SearchResultsPage = require('./SearchResultsPage.scss');var styles = _interopRequireWildcard(_SearchResultsPage);
var _messageModal = require('../../redux/modules/messageModal');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Redux
// Styles
var DESKTOP_COMPANY_POSITION = 6;var MOBILE_COMPANY_POSITION = 5;var SearchResultsPage = function (_Component) {_inherits(SearchResultsPage, _Component);function SearchResultsPage(props) {_classCallCheck(this, SearchResultsPage);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.


















































































































































































































































































































    setUpFavoritesAnalytics = function (id) {
      var existingFavorites = _this.props.favoriteProperties.favoriteIDs;
      var clickedIndex = existingFavorites.indexOf(id);
      var isFavorite = clickedIndex !== -1;
      (0, _analyticsManager.trackEvent)(
      _analyticsConstants.eventCategory.favorites,
      isFavorite ? _analyticsConstants.eventAction.remove : _analyticsConstants.eventAction.add,
      _analyticsConstants.eventLabel.searchPage);

    };_this.

    getEntityTypeById = function (entityId) {return (
      _this.findById(_this.props.properties, entityId) ||
      _this.findById(_this.props.propertyPins, entityId) ||
      {}).
      entityType;};_this.

    findById = function (collection, id) {return collection.find(function (item) {return item.id === id;});};_this.


    geocodeAddress = function (address, tags) {return (
        // eslint-disable-next-line no-new
        new _googleService2.default(_this.props.locale, function (googleService) {return (
            googleService.geocodeLocusViaInternalBase(address, tags).then(function () {var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var newRouteData = Object.assign({},
              _this.props.routeData, {
                locationSearch: Object.assign({},
                _this.props.routeData.locationSearch,
                result) });


              var newRoute = (0, _routerAdapter.createUrl)(newRouteData);
              _reactRouter.browserHistory.replace({
                pathname: newRoute,
                state: newRouteData });

            }));}));};_this.


    performSearch = function (_ref)



    {var routeData = _ref.routeData,isMobile = _ref.isMobile,loading = _ref.loading,citiesLoading = _ref.citiesLoading,citiesData = _ref.citiesData,loadingPins = _ref.loadingPins,mobileMapIsVisible = _ref.mobileMapIsVisible;var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},oldRouteData = _ref2.routeData;var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},_ref3$listOnly = _ref3.listOnly,listOnly = _ref3$listOnly === undefined ? false : _ref3$listOnly,_ref3$pinsOnly = _ref3.pinsOnly,pinsOnly = _ref3$pinsOnly === undefined ? false : _ref3$pinsOnly,_ref3$mountLoad = _ref3.mountLoad,mountLoad = _ref3$mountLoad === undefined ? false : _ref3$mountLoad;
      // Don't search if going to other then SearchResults
      if (!routeData || !_this.state.sectionNames.includes(routeData.location)) {
        return;
      }

      // Here be dragons, sorry - the combination of conditions was chosen by trial and error
      // TODO: Needs heavy request optimisations

      var mapLoaded =
      !!routeData.mapLoaded || oldRouteData && oldRouteData.mapLoaded || mobileMapIsVisible;

      var shouldLoadPins = mapLoaded || routeData.firstLoad; // If desktop and map loaded and it's not city pin view - get pins
      var getCells = !loading && isMobile || isMobile === null || mapLoaded; // If mobile or only when the map is loaded on desktop
      var requestObject = null;

      var performSearchList = !pinsOnly && getCells;
      var performSearchPins = !listOnly && shouldLoadPins;
      var firstModalLoad =
      !!(!performSearchPins &&
      !isMobile &&
      !loadingPins &&
      !mapLoaded &&
      shouldLoadPins === undefined &&
      !!(
      routeData.searchResultParams &&
      routeData.searchResultParams.propertyId)) ||

      mountLoad;

      performSearchPins = performSearchPins || firstModalLoad;
      performSearchList = performSearchList || firstModalLoad;

      if (performSearchList || performSearchPins) {
        try {var _ref4 =
          routeData.locationSearch || {},isCity = _ref4.isCity,isFull = _ref4.isFull,isNeighborhood = _ref4.isNeighborhood;
          var isStreet = routeData.locationSearch && !isCity && !isFull && !isNeighborhood;
          var data = !mapLoaded && (isStreet || isNeighborhood) ? Object.assign({},

          routeData, {
            locationSearch: (0, _omit2.default)(routeData.locationSearch, ['map', 'location']) }) :

          routeData;
          requestObject = (0, _formatObjectToQuery2.default)(data);
        } catch (err) {
          console.error(err);
          return;
        }
      }

      if (performSearchList) {
        _this.props.saveRecentSearch(routeData);
        if (_this.props.sort) {
          requestObject.$sort = _this.props.sort;
        }
        var searchCountParams = { params: requestObject, type: routeData.location };
        var searchPropertyParams = { params: Object.assign({}, requestObject, { is_mobile: isMobile }), type: routeData.location };

        _this.props.searchProperty(searchPropertyParams);
        _this.props.receivePropertiesCount(searchCountParams);
        // this.props.receiveProjectsCount(searchParams);
      }

      if (!pinsOnly && isMobile && mobileMapIsVisible === null) {
        return;
      }

      if (performSearchPins) {
        _this.props.loadPins({ params: Object.assign({}, requestObject, { is_mobile: isMobile }), type: routeData.location });
        _this.props.searchAgencies([
        requestObject,
        routeData.locationSearch && routeData.locationSearch.zoom]);

      }
    };_this.

    showSaveSearchLocationStatus = function (newData) {var
      saveSearchLocation = _this.props.saveSearchLocation;
      var submitFinished = saveSearchLocation.submitting && !newData.submitting;
      var submitIsSuccessful = submitFinished && newData.submitted && !newData.error;
      var submitIsFailed = submitFinished && !newData.submitted && newData.error;
      var userEmail = (0, _get2.default)(_this.props, 'userAuthentication.data.email');

      var successContent =
      _react2.default.createElement('div', { className: styles.saveSearchStatus },
        _react2.default.createElement('h3', null, _this.props.translate('saveSearchLocation', 'successTitle')),
        _react2.default.createElement('p', null, _this.props.translate('saveSearchLocation', 'successMessage')),
        _react2.default.createElement('div', null, _react2.default.createElement('i', { className: 'icon icon-check' }), '\xA0', userEmail));



      var errorContent =
      _react2.default.createElement('div', { className: styles.saveSearchStatus },
        _react2.default.createElement('h3', null, _this.props.translate('saveSearchLocation', 'errorMessage')));



      var message = submitIsSuccessful ? successContent : errorContent;

      if (submitIsSuccessful || submitIsFailed) {
        _this.props.openMessageModal({
          message: message });

      }
    };_this.

    checkIsProjectsPage = function () {
      var location = (0, _get2.default)(_this.props, 'routeData.location');
      return location === 'projects';
    };_this.

    checkPopupIsOpen = function (routeData) {
      var directLink = global.history && global.history.length <= 2;
      var propertyId = (0, _get2.default)(routeData, 'searchResultParams.propertyId', false);

      if (directLink && _this.props.isMobile && propertyId) {
        var route = (0, _appendLocale2.default)(
        _this.props.locale, '/home_details/' +
        propertyId);

        _reactRouter.browserHistory.push(route);
      }

      if (propertyId && !_this.props.isMobile && !_this.props.isDetailsModalOpen) {
        setTimeout(function () {return (
            _this.props.openDetailsPopup({ propertyId: propertyId }));},
        1000);

      }
    };_this.

    highlightPin = function (propertyData) {return (
        _this.setState({ highlightedProperty: propertyData }));};_this.

    disableHighlightPin = function () {return _this.setState({ highlightedProperty: null });};_this.

    handlePopupOpen = function (preloadData) {
      preloadData = Object.assign({},
      preloadData, {
        entityType: preloadData.entityType || _this.getEntityTypeById(preloadData.propertyId) });


      _this.updateRoute({
        searchResultParams: { propertyId: preloadData.propertyId } });

      // hermione event
      if (!_this.checkIsProjectsPage()) {
        _services.AnalyticsEventService.createPropertyEvent({
          propertyId: preloadData.propertyId,
          action: _constants.analyticsEventAction.VIEW });

      }

      setTimeout(function () {
        _this.props.openDetailsPopup(Object.assign({},
        preloadData, {
          optionType: _this.props.routeData.optionType }));

      }, 0);
    };_this.

    updateRoute = function (data) {
      var state = Object.assign({}, _this.props.routeData, data);
      var pathname = (0, _routerAdapter.createUrl)(state);
      if (pathname !== state.route) {
        state.route = pathname;
        _reactRouter.browserHistory.push({ pathname: pathname, state: state });
      }
    };_this.

    handleOpenFilters = function () {
      // analytics
      (0, _analyticsManager.trackEvent)(
      _analyticsConstants.eventCategory.searchResults,
      _analyticsConstants.eventAction.click,
      _analyticsConstants.eventLabel.filter);

      var optionType = (0, _get2.default)(_this.props, 'routeData.optionType');
      var location = (0, _get2.default)(_this.props, 'routeData.location');
      var isProjects = location === 'projects';
      _this.props.openMobileFilters({ optionType: optionType, isProjects: isProjects });
    };_this.

    handleListSelect = function () {var
      favoritesListIsActive = _this.props.favoriteProperties.favoritesListIsActive;
      var isFavoriteWillBeShown = !favoritesListIsActive;
      _this.props.setFavoritesListState(isFavoriteWillBeShown);
      // analytics
      if (isFavoriteWillBeShown) {
        (0, _analyticsManager.trackEvent)(
        _analyticsConstants.eventCategory.searchResults,
        _analyticsConstants.eventAction.click,
        _analyticsConstants.eventLabel.favorites);

      } else {
        (0, _analyticsManager.trackEvent)(
        _analyticsConstants.eventCategory.searchResults,
        _analyticsConstants.eventAction.click,
        _analyticsConstants.eventLabel.list);

      }
      var data = isFavoriteWillBeShown ? _constants.clearFiltersInitialValues : {};
      _this.updateRoute(Object.assign({}, data, { favorites: isFavoriteWillBeShown }));
    };_this.

    addPropertyNote = function (id, note) {var
      token = _this.props.userToken;
      // analytics
      (0, _analyticsManager.trackEvent)(
      _analyticsConstants.eventCategory.notes,
      _analyticsConstants.eventAction.add,
      _analyticsConstants.eventLabel.searchResultsPage);

      _this.props.addPropertyNote({ noteData: { id: id, note: note }, token: token });
    };_this.

    toggleFavorite = function (id, container, isProject) {
      var array = container === 'map' ? 'propertyPins' : 'properties';
      // analytics
      _this.setUpFavoritesAnalytics(id);
      var property = _this.findPropertyById(id, array)[0];
      _this.props.toggleFavorite({ property: property, token: _this.props.userToken, isProject: isProject });
    };_this.

    fitMapBoundsToFavorites = function () {return _this.setState({ fitMapToFavorites: true });};_this.

    findPropertyById = function (id, array) {
      var propertiesData = _this.props.favoriteProperties.favoritesListIsActive ?
      _this.state.filteredFavorites :
      _this.props[array];

      return propertiesData.filter(function (property) {return property.id === id;});
    };_this.

    saveSearchLocation = function () {
      _this.props.openSaveSearchLocationModal();
    };_this.

    saveSearchData = function (name) {var
      routeData = _this.props.routeData;
      var userEmail = (0, _get2.default)(_this.props, 'userAuthentication.data.email');
      var data = Object.assign({
        name: name },
      routeData);


      if (!(0, _get2.default)(routeData, 'locationSearch.map')) {
        data.locationSearch = Object.assign({},
        routeData.locationSearch,
        _constants.clearFiltersInitialValues.locationSearch);

      }

      var polygonData = _constants.storage.value.getItem('polygonCoordinates');
      if (polygonData) {
        try {var _JSON$parse =
          JSON.parse(polygonData),coords = _JSON$parse.coords;
          data.drawn = coords;
        } catch (err) {
          console.error(err);
        }
      }

      var locationSearch = (0, _get2.default)(routeData, 'locationSearch') || {};

      if (locationSearch.isNeighborhood && locationSearch.polygon) {
        data.drawn = locationSearch.polygon;
      }

      _this.props.saveSearchData({
        data: data,
        token: _this.props.userToken,
        userEmail: userEmail,
        locale: _this.props.locale === 'fr' ? 'en' : _this.props.locale });

    };_this.

    handleLoadMore = function (params) {return _this.props.loadMore(Object.assign({
        is_mobile: _this.props.isMobile },
      params));};_this.


    isLargeSideBar = function () {return !_this.props.isMobile && (0, _get2.default)(_this.props, 'routeData.location') !== 'projects';};_this.

    renderNoFavoritesMessage = function () {var
      favoriteIDs = _this.props.favoriteProperties.favoriteIDs;
      var noFavoritesOnMap =
      _this.props.favoriteProperties.favoritesListIsActive &&
      favoriteIDs &&
      favoriteIDs.length &&
      !_this.state.filteredFavorites.length;

      var shouldBeRender =
      _this.props.isMobile && _this.props.mobileMapIsVisible && noFavoritesOnMap;

      return shouldBeRender ?
      _react2.default.createElement('div', { className: styles.noFavoritesMessage },
        _react2.default.createElement('div', { className: styles.noResults },
          _this.props.translate('favoritesNoResults', 'noPropertiesOnMap')),

        _react2.default.createElement('div', { className: styles.displayAll },
          _this.props.translate('favoritesNoResults', 'displayAll'),
          _react2.default.createElement('span', { onClick: _this.fitMapBoundsToFavorites }, '\xA0',
            _this.props.translate('favoritesNoResults', 'clickHere')))) :



      null;
    };_this.

    renderPropertiesList = function () {
      var propertiesArray = _this.props.favoriteProperties.favoritesListIsActive ?
      _this.state.filteredFavorites :
      _this.props.properties;

      return (
        _react2.default.createElement(_components.PropertiesList, {
          companyFindByNeighborhood: _this.props.companyFindByNeighborhood,
          updateRoute: _this.updateRoute,
          containerRef: _this.scrollParentRef,
          properties: propertiesArray || [],
          openDetailsPopup: _this.handlePopupOpen,
          loadMore: _this.handleLoadMore,
          translate: _this.props.translate,
          translateCities: _this.props.translateCities,
          translateProjects: _this.props.translateProjects,
          isLastPage:
          _this.props.favoriteProperties.favoritesListIsActive ?
          true :
          _this.props.isLastPage,

          locale: _this.props.locale,
          loading: _this.props.loading,
          loaded: _this.props.loaded,
          openFilters: _this.handleOpenFilters,
          highlightPin: _this.highlightPin,
          disableHighlightPin: _this.disableHighlightPin,
          isMobile: _this.props.isMobile,
          publishClicked: _this.props.publishClicked,
          propertyNotes: _this.props.propertyNotes,
          addPropertyNote: _this.addPropertyNote,
          favoriteProperties: _this.props.favoriteProperties.favoriteIDs,
          toggleFavorite: _this.toggleFavorite,
          displayAllFavorites: _this.fitMapBoundsToFavorites,
          isFavoritesList: _this.props.favoriteProperties.favoritesListIsActive,
          isMobileFiltersOpen: _this.props.isMobileFiltersOpen,
          isRtl: _this.props.isRtl,
          routeData: _this.props.routeData,
          propertiesQuantity: _this.props.propertiesCount,
          projectsQuantity: _this.props.projectsCount,
          searchProperty: _this.props.searchProperty,
          skip: _this.props.skip,
          suppressLoading: _this.props.suppressLoading,
          setPreloadData: _this.props.setPreloadData,
          saveSearchLocation: _this.saveSearchLocation,
          isLargeSideBar: _this.isLargeSideBar() }));


    };_this.

    renderMapContainer = function () {var _this$props =












      _this.props,isMobile = _this$props.isMobile,isRtl = _this$props.isRtl,translate = _this$props.translate,cityPolygon = _this$props.cityPolygon,locale = _this$props.locale,query = _this$props.query,routeData = _this$props.routeData,citiesData = _this$props.citiesData,_this$props$favoriteP = _this$props.favoriteProperties,favoritesListIsActive = _this$props$favoriteP.favoritesListIsActive,favoritesData = _this$props$favoriteP.favoritesData,mobileMapIsVisible = _this$props.mobileMapIsVisible,isMobileFiltersOpen = _this$props.isMobileFiltersOpen;

      if (isMobile && !mobileMapIsVisible) {
        return null;
      }

      var isProjects = routeData && routeData.location === 'projects';var _this$state =
      _this.state,highlightedProperty = _this$state.highlightedProperty,isTablet = _this$state.isTablet;
      var propertyPins = _this.props.favoriteProperties.favoritesListIsActive ?
      _this.state.filteredFavorites :
      _this.props.propertyPins;
      var propertiesIdsMap = (propertyPins || []).reduce(function (acc, property) {
        acc[property.id] = Object.assign({}, property);
        return acc;
      }, {});

      return (
        _react2.default.createElement('div', { style: Object.assign({ height: '100%' }, isMobile && _this.props.mobileMapIsVisible === false ? { display: 'none' } : {}) },
          _react2.default.createElement(_containers.MapContainer, {
            findByNeighborhood: _this.props.findByNeighborhood,
            resetNeighborhoodCompany: _this.props.resetNeighborhoodCompany,
            userToken: _this.props.userToken,
            isMobileFiltersOpen: isMobileFiltersOpen,
            favoritesData: favoritesData,
            translate: translate,
            propertyPins: propertyPins || [],
            propertiesIdsMap: propertiesIdsMap,
            agencies: isProjects ? [] : _this.props.agencies || [],
            cityOrNeighborhoodPolygon: cityPolygon,
            cityOrNeighborhoodPolygonName: _this.props.cityPolygonName,
            locale: locale,
            query: query,
            openDetailsPopup: _this.handlePopupOpen,
            routeData: routeData,
            citiesData: citiesData,
            highlightedProperty: highlightedProperty,
            isTablet: isTablet,
            isMobile: isMobile,
            favoriteProperties: _this.props.favoriteProperties.favoriteIDs,
            toggleFavorite: function toggleFavorite(id) {return _this.toggleFavorite(id, 'map');},
            isFavoritesPins: favoritesListIsActive,
            fitMapToFavorites: _this.state.fitMapToFavorites,
            mobileMapIsVisible: isMobile,
            mobileMapIsHidden: isMobile && _this.props.mobileMapIsVisible === false,
            resetFavoritesFilter: function resetFavoritesFilter() {return (
                _this.setState({
                  filteredFavorites: _this.props.favoriteProperties.favoritesData }));},


            saveFilteredFavorites: function saveFilteredFavorites(filteredFavorites) {return (
                _this.setState({ filteredFavorites: filteredFavorites, fitMapToFavorites: false }));},

            setPinAsReviewed: _this.props.setPinAsReviewed,
            reviewedPins: _this.props.reviewedPins,
            isRtl: isRtl,
            openAdvancedFilters: _this.props.openAdvancedFilters,
            favoritesHandler: function favoritesHandler() {
              _this.props.setFavoritesListState(
              !_this.props.favoriteProperties.favoritesListIsActive);

            },
            propertiesQuantity: _this.props.propertiesCount,
            projectsQuantity: _this.props.projectsCount,
            pinsLoading: _this.props.loadingPins,
            suppressLoading: _this.props.suppressLoading,
            isProjects: _this.checkIsProjectsPage(),
            isLargeSideBar: _this.isLargeSideBar() })));



    };_this.

    renderScrollWrapper = function (properties) {var
      elementRef = properties.elementRef,restProps = _objectWithoutProperties(properties, ['elementRef']);
      return _react2.default.createElement('div', _extends({}, restProps, { ref: elementRef, className: styles.customScrollWrapper }));
    };_this.

    renderScrollTrack = function (properties) {var
      elementRef = properties.elementRef,restProps = _objectWithoutProperties(properties, ['elementRef']);
      return _react2.default.createElement('div', _extends({}, restProps, { ref: elementRef, className: styles.customScrollTrack }));
    };_this.

    renderScrollThumb = function (properties) {var
      elementRef = properties.elementRef,restProps = _objectWithoutProperties(properties, ['elementRef']);
      return _react2.default.createElement('div', _extends({}, restProps, { ref: elementRef, className: styles.customScrollThumb }));
    };_this.

    renderScrollContent = function (properties) {var
      elementRef = properties.elementRef,restProps = _objectWithoutProperties(properties, ['elementRef']);
      return (
        _react2.default.createElement('div', _extends({},
        restProps, {
          id: 'side-bar',
          ref: function ref(_ref5) {_this.scrollParentRef = _ref5;elementRef(_ref5);} })));


    };_this.

    renderDesktopContent = function () {var _cx;var

      favoritesListIsActive =
      _this.props.favoriteProperties.favoritesListIsActive;

      return (
        _react2.default.createElement('div', { className: styles.desktopContent },
          _react2.default.createElement(_containers.LineFilterContainer, {
            propertyTypes: _this.props.propertyTypes,
            routeData: _this.props.routeData,
            translate: _this.props.translate,
            locale: _this.props.locale,
            openAdvancedFilters: _this.props.openAdvancedFilters,
            favoritesListIsActive: favoritesListIsActive,
            setFavoritesListState: _this.handleListSelect,
            saveSearchLocation: _this.saveSearchLocation }),


          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.sideBar, (_cx = {}, _cx[styles.largeSideBar] = _this.isLargeSideBar(), _cx)) },
            _react2.default.createElement(_reactScrollbarsCustom2.default, {
                rtl: _this.props.isRtl,
                wrapperRenderer: _this.renderScrollWrapper,
                trackYRenderer: _this.renderScrollTrack,
                thumbYRenderer: _this.renderScrollThumb,
                contentRenderer: _this.renderScrollContent },

              _this.renderPropertiesList()),


            _react2.default.createElement(_containers.AdvancedFilters, { isRtl: _this.props.isRtl })),


          _react2.default.createElement('div', { className: styles.map }, _this.renderMapContainer())));


    };_this.

    renderSwitchButton = function () {var _cx2;
      if (!_this.props.isMobile) {
        return null;
      }
      var favoritesListIsActive = (0, _get2.default)(
      _this.props,
      'favoriteProperties.favoritesListIsActive');

      var switchListTitle = _this.props.mobileMapIsVisible ?
      _this.props.translate('mobileTabs', 'showList')() :
      _this.props.translate('mobileTabs', 'showMap')();

      var switchListIcon = _this.props.mobileMapIsVisible ?
      'icon-search-list' :
      'icon-search-map';

      var analyticsEvent = _this.props.mobileMapIsVisible ?
      function () {return (
          (0, _analyticsManager.trackEvent)(
          _analyticsConstants.eventCategory.searchResults,
          _analyticsConstants.eventAction.click,
          _analyticsConstants.eventLabel.list));} :

      function () {};
      var toggleTab = function toggleTab() {
        analyticsEvent();
        _this.props.toggleMobileMap();
      };
      var isProjects = _this.checkIsProjectsPage();

      return (
        _react2.default.createElement('div', {
            className: (0, _classnames2.default)(styles.switchButtonContainer, (_cx2 = {}, _cx2[
            styles.switchButtonContainerFav] = favoritesListIsActive, _cx2)) },


          favoritesListIsActive ?
          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.btnSwitcher, styles.btnSwitcherFavorites) },
            _react2.default.createElement('div', null, _this.props.translate('header', 'favorites')),
            _react2.default.createElement('button', { onClick: toggleTab }, switchListTitle)) :


          _react2.default.createElement('div', { className: styles.btnSwitcher },
            _react2.default.createElement('button', { onClick: _this.handleOpenFilters },
              _react2.default.createElement('div', { className: styles.filterWrapper },
                _react2.default.createElement('i', { className: 'icon icon-search-filter' }),
                _this.props.activeFiltersQuantity > 0 &&
                _react2.default.createElement('div', { className: styles.filterCounter },
                  _this.props.activeFiltersQuantity)),



              _react2.default.createElement('div', null, _this.props.translate('mobileTabs', 'showFilters')())),


            !isProjects && _react2.default.createElement('span', null),
            !isProjects &&
            _react2.default.createElement('button', { onClick: _this.saveSearchLocation },
              _react2.default.createElement('i', { className: 'icon icon-search-save' },
                _react2.default.createElement('i', { className: 'path1' }),
                _react2.default.createElement('i', { className: 'path2' }),
                _react2.default.createElement('i', { className: 'path3' })),

              _react2.default.createElement('div', null, _this.props.translate('mobileTabs', 'saveSearchLocation')())),



            _react2.default.createElement('span', null),

            _react2.default.createElement('button', { onClick: toggleTab },
              _react2.default.createElement('i', { className: 'icon ' + switchListIcon }),
              _react2.default.createElement('div', null, switchListTitle)))));





    };_this.

    renderMobileContent = function () {return (
        _react2.default.createElement('div', { className: styles.mobilePropertiesListWrapper },
          _this.renderSwitchButton(),
          _this.props.mobileMapIsVisible !== null && _this.renderMapContainer(),
          !_this.props.mobileMapIsVisible && _this.renderPropertiesList(),
          _this.props.mobileMapIsVisible && _this.renderNoFavoritesMessage()));};_this.state = { sectionNames: (0, _constants.getSectionsNames)(), highlightedProperty: null, isTablet: _checkUserAgent2.default.isMobileOrTablet(navigator.userAgent), fitMapToFavorites: false, filteredFavorites: _this.props.favoriteProperties.favoritesData || [] };_this.props.setFavoritesListState(_this.props.routeData.favorites);return _this;}SearchResultsPage.prototype.componentDidMount = function componentDidMount() {var _this2 = this;if (this.props.isMobile) {var filtersQuantity = (0, _calculateMobileActiveFiltersQuantity2.default)(this.props.routeData);this.props.changeActiveFiltersQuantity(filtersQuantity);}var loadType = (0, _getLoadType2.default)();var _props$routeData = this.props.routeData,locationSearch = _props$routeData.locationSearch,searchResultParams = _props$routeData.searchResultParams;var ignoreGeocode = _constants.language.ignoredLanguages.includes(this.props.locale);var neighborhood = (0, _get2.default)(this.props, 'routeData.locationSearch.en.neighborhood');var city = (0, _get2.default)(this.props, 'routeData.locationSearch.en.city_name');var formatObject = (0, _formatObjectToQuery2.default)(this.props.routeData);if (neighborhood && city || formatObject.neighborhood && formatObject.city) {this.props.findByNeighborhood({ city: city || formatObject.city, neighborhood: neighborhood || formatObject.neighborhood });}if (loadType || this.props.isMobile) {if (this.props.suppressLoad) {this.props.suppressLoading(false);} else {this.performSearch(this.props, undefined, { mountLoad: !this.props.isMobile });}}var localisedLocationData = (0, _get2.default)(locationSearch, this.props.locale, null);if (!ignoreGeocode && !localisedLocationData) {var cityName = (0, _get2.default)(locationSearch, 'en.city_name', '');var neighborhoodName = (0, _get2.default)(locationSearch, 'en.neighborhood', '');var streetName = (0, _get2.default)(locationSearch, 'en.street_name', '');var address = (cityName + ' ' + neighborhoodName + ' ' + streetName).trim();var tags = [];if (cityName) {tags.push(cityName);if (streetName) {tags.push(streetName);} else if (neighborhoodName) {tags.push(neighborhoodName);}}var cleanedTags = tags.filter(function (part) {return !!part;}).map(function (keyPart) {return (0, _slugify2.default)(keyPart);});if (address) {this.geocodeAddress(address, cleanedTags);}}if (this.props.userToken && !this.props.favoriteProperties.favoriteIDs.length) {this.props.loadFavorites(this.props.userToken);}if (searchResultParams && searchResultParams.propertyId) {// hermione event - should be fired from client side only, so only client lifecycle methods are ok
      if (!this.checkIsProjectsPage()) {_services.AnalyticsEventService.createPropertyEvent({ propertyId: searchResultParams.propertyId, action: _constants.analyticsEventAction.VIEW });}}setTimeout(function () {return _this2.checkPopupIsOpen(_this2.props.routeData);}, 0);};SearchResultsPage.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {var _props = this.props,oldRoute = _props.route,_props$routeData2 = _props.routeData,oldCancel = _props$routeData2.cancelDraw,oldFirstLoad = _props$routeData2.firstLoad,oldPage = _props$routeData2.location,oldDrawnPoly = _props$routeData2.drawnPoly,oldLocationSearch = _props$routeData2.locationSearch,wasMobileMap = _props.mobileMapIsVisible;var newRoute = newProps.route,_newProps$routeData = newProps.routeData,newCancel = _newProps$routeData.cancelDraw,firstLoad = _newProps$routeData.firstLoad,optionType = _newProps$routeData.optionType,page = _newProps$routeData.location,locationSearch = _newProps$routeData.locationSearch,drawnPoly = _newProps$routeData.drawnPoly,pointCoordinates = _newProps$routeData.pointCoordinates,nowMobileMap = newProps.mobileMapIsVisible;var sectionNames = this.state.sectionNames;var searchResult = (0, _get2.default)(this.props, 'routeData.searchResultParams');var newSearchResult = (0, _get2.default)(newProps, 'routeData.searchResultParams');var newPropertyId = (0, _get2.default)(newSearchResult, 'propertyId', null);var oldPropertyId = (0, _get2.default)(searchResult, 'propertyId', null);var abortIfPopupTriggered = !!(newPropertyId || oldPropertyId);var neighborhood = (0, _get2.default)(newProps, 'routeData.locationSearch.en.neighborhood');var oldNeighborhood = (0, _get2.default)(this.props, 'routeData.locationSearch.en.neighborhood');var city_name = (0, _get2.default)(newProps, 'routeData.locationSearch.en.city_name');this.showSaveSearchLocationStatus(newProps.saveSearchLocation);if (neighborhood && neighborhood !== oldNeighborhood && city_name) {this.props.findByNeighborhood({ city: city_name, neighborhood: neighborhood });}if (!wasMobileMap && nowMobileMap) {this.performSearch(newProps, this.props);}if (!this.props.userToken && newProps.userToken) {this.props.loadFavorites(newProps.userToken);}if (newProps.favoriteProperties) {var _newProps$favoritePro = newProps.favoriteProperties,favoritesListIsActive = _newProps$favoritePro.favoritesListIsActive,favoriteIDs = _newProps$favoritePro.favoriteIDs;var stateModifier = {};if (favoritesListIsActive !== this.props.favoriteProperties.favoritesListIsActive) {if (favoritesListIsActive) {this.prevRouteData = Object.assign({}, (0, _cloneDeep2.default)(this.props.routeData), { route: '' });} else if (this.prevRouteData && this.prevRouteData.location === page && this.prevRouteData.optionType === optionType) {this.updateRoute(this.prevRouteData);}if (favoritesListIsActive && newProps.userToken && !favoriteIDs.length) {this.props.loadFavorites(this.props.userToken);}}if (!favoritesListIsActive && this.props.favoriteProperties.favoriteIDs.length !== favoriteIDs.length || this.props.favoriteProperties.favoritesListIsActive && !favoritesListIsActive || !this.state.filteredFavorites.length && newProps.favoriteProperties.favoritesData) {stateModifier.filteredFavorites = newProps.favoriteProperties.favoritesData;}if (Object.keys(stateModifier).length) {this.setState(stateModifier);}}var isSectionChanged = sectionNames.includes(page) && oldPage !== page;var isOptionTypeChanged = optionType !== this.props.routeData.optionType;var isFavoritesIsActive = (0, _get2.default)(newProps, 'favoriteProperties.favoritesListIsActive');if (isFavoritesIsActive && (isSectionChanged || isOptionTypeChanged)) {this.props.setFavoritesListState(false);}if (isSectionChanged) {var clearRouteData = Object.assign({}, _constants.clearFiltersInitialValues, { locationSearch: locationSearch, drawnPoly: drawnPoly, pointCoordinates: pointCoordinates, location: page, route: newRoute, favorites: false, optionType: page === 'projects' ? null : optionType });this.updateRoute(clearRouteData);this.performSearch(newProps, this.props);return;}if (!sectionNames.includes(page) || sectionNames.includes(page) && page !== 'projects' && !optionType || abortIfPopupTriggered) {return;}var loadedMap = firstLoad ? !oldFirstLoad : oldFirstLoad; // XOR
    if (loadedMap || newRoute !== oldRoute || newCancel && newCancel !== oldCancel) {if (newProps.isAdvancedFiltersOpen) {this.props.hideAdvancedFilters();}this.performSearch(newProps, this.props);} else if (newProps.submitting) {this.props.hideMobileFilters();}if (this.props.properties !== newProps.properties && newProps.companyFindByNeighborhood.data && !newProps.skip) {if (newProps.properties.length >= DESKTOP_COMPANY_POSITION) {newProps.properties.splice(newProps.isMobile ? MOBILE_COMPANY_POSITION : DESKTOP_COMPANY_POSITION, 0, { companyFindByNeighborhood: newProps.companyFindByNeighborhood.data });} else if (newProps.properties.length < DESKTOP_COMPANY_POSITION) {newProps.properties.splice(newProps.properties.length, 0, { companyFindByNeighborhood: newProps.companyFindByNeighborhood.data });}}var companyWasReset = !newProps.companyFindByNeighborhood.data && !!this.props.companyFindByNeighborhood.data;if (newProps.properties && companyWasReset) {var companyIndex = newProps.properties.findIndex(function (item) {return !!item.companyFindByNeighborhood;});if (companyIndex >= 0) {newProps.properties.splice(companyIndex, 1);}}};SearchResultsPage.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref6, _ref7) {var routeData = _ref6.routeData;var sectionNames = _ref7.sectionNames; // If still on this page
    var shouldUpdate = !!(sectionNames.includes(routeData.location) && (routeData.optionType || routeData.location === 'projects'));return shouldUpdate;};SearchResultsPage.prototype.componentWillUpdate = function componentWillUpdate(newProps) {var favoritesListIsActive = newProps.favoriteProperties.favoritesListIsActive;if (this.props.favoriteProperties.favoritesListIsActive !== favoritesListIsActive) {// List on mobile
      if (newProps.isMobile && favoritesListIsActive && newProps.route !== this.props.route) {this.performSearch(newProps, this.props, { listOnly: true });}}};SearchResultsPage.prototype.componentDidUpdate = function componentDidUpdate(oldProps) {var oldDrawnPoly = oldProps.routeData.drawnPoly;var drawnPoly = this.props.routeData.drawnPoly;if (drawnPoly && drawnPoly !== oldDrawnPoly) {this.performSearch(this.props, oldProps);}};SearchResultsPage.prototype.componentWillUnmount = function componentWillUnmount() {var userNotAuthorised = !this.props.userToken;if (userNotAuthorised) {this.props.saveFavoritesData();}this.props.setFavoritesListState(false);if (!this.props.isMobile) {this.props.clearPropertiesList();}}; // Called only once, so is not necessary save an instance of Google Service
  SearchResultsPage.prototype.render = function render() {var _this3 = this;var _props2 = this.props,isMobile = _props2.isMobile,route = _props2.route;
    var canonicalUrl = (0, _generateCanonicalLink2.default)(this.props.routeData);
    var titleContent = (0, _index.getSearchTitle)(
    this.props.routeData,
    this.props.translate);

    var ogTitleContent = (0, _formatSEOData.formatSearchTitle)(
    this.props.routeData,
    this.props.translate);

    var descriptionContent = (0, _formatSEOData.formatSearchDescription)(
    this.props.routeData,
    this.props.translate);

    var multiLanguage = (0, _multiLanguageHeadTags2.default)(canonicalUrl, this.props.locale);

    var helmetMeta = [
    { name: 'description', content: descriptionContent },
    { property: 'og:url', content: '' + _constants.shareUrl + route },
    { property: 'og:title', content: ogTitleContent + ' | \u202BOnMap' },
    { property: 'og:description', content: descriptionContent }];


    return (
      _react2.default.createElement('div', { className: styles.searchPage },
        _react2.default.createElement(_reactHelmet2.default, {
          titleTemplate: this.props.translate('title', 'titleTemplate')(),
          title: titleContent,
          meta: helmetMeta,
          link: [].concat(
          multiLanguage, [
          { rel: 'canonical', href: '' + _constants.shareUrl + canonicalUrl }]) }),



        isMobile ? this.renderMobileContent() : this.renderDesktopContent(),

        _react2.default.createElement(_components.SaveSearchLocationModal, _extends({},
        this.props.saveSearchLocation, {
          routeData: this.props.routeData,
          isRtl: this.props.isRtl,
          translate: this.props.translate,
          isMobile: this.props.isMobile,
          close: function close() {return _this3.props.closeSaveSearchLocationModal();} // Required for not passing evt to action creator
          , saveSearchData: this.saveSearchData,
          socialNetworkAuthentication: this.props.socialNetworkAuthentication,
          userToken: this.props.userToken,
          isLoggedIn: !!this.props.userToken,
          auth: this.props.authenticateUser,
          editUserProfile: this.props.editUserProfile,
          userAuthentication: this.props.userAuthentication,
          logOut: this.props.logOut,
          openAuthenticationModal: this.props.openAuthenticationModal,
          locale: this.props.locale }))));



  };return SearchResultsPage;}(_react.Component);


SearchResultsPage.displayName = 'SearchResultsPage';
SearchResultsPage.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  routeData: _propTypes2.default.object.isRequired,
  route: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  translateCities: _propTypes2.default.func,
  translateProjects: _propTypes2.default.func,
  agencies: _propTypes2.default.array,
  properties: _propTypes2.default.array,
  propertyPins: _propTypes2.default.array,
  cityPolygon: _propTypes2.default.array,
  cityPolygonName: _propTypes2.default.string,
  citiesData: _propTypes2.default.array,
  loadMore: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func,
  isLastPage: _propTypes2.default.bool,
  query: _propTypes2.default.object,
  searchProperty: _propTypes2.default.func,
  searchAgencies: _propTypes2.default.func,
  loadPins: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  loadingPins: _propTypes2.default.bool,
  loaded: _propTypes2.default.bool,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  openMobileFilters: _propTypes2.default.func,
  hideMobileFilters: _propTypes2.default.func,
  openAdvancedFilters: _propTypes2.default.func.isRequired,
  hideAdvancedFilters: _propTypes2.default.func.isRequired,
  publishClicked: _propTypes2.default.func.isRequired,
  propertyNotes: _propTypes2.default.array,
  propertyTypes: _propTypes2.default.object,
  favoriteProperties: _propTypes2.default.object,
  addPropertyNote: _propTypes2.default.func,
  toggleFavorite: _propTypes2.default.func,
  loadFavorites: _propTypes2.default.func,
  setFavoritesListState: _propTypes2.default.func,
  saveFavoritesData: _propTypes2.default.func,
  setPinAsReviewed: _propTypes2.default.func,
  reviewedPins: _propTypes2.default.array,
  isRtl: _propTypes2.default.bool,
  isMobileFiltersOpen: _propTypes2.default.bool,
  userToken: _propTypes2.default.string,
  receivePropertiesCount: _propTypes2.default.func,
  receiveProjectsCount: _propTypes2.default.func,
  propertiesCount: _propTypes2.default.number,
  projectsCount: _propTypes2.default.number,
  skip: _propTypes2.default.number,
  sort: _propTypes2.default.string,
  suppressLoad: _propTypes2.default.bool,
  suppressLoading: _propTypes2.default.func,
  mobileMapIsVisible: _propTypes2.default.bool,
  toggleMobileMap: _propTypes2.default.func,
  setPreloadData: _propTypes2.default.func,
  openSaveSearchLocationModal: _propTypes2.default.func,
  saveSearchData: _propTypes2.default.func,
  closeSaveSearchLocationModal: _propTypes2.default.func,
  saveSearchLocation: _propTypes2.default.object,
  socialNetworkAuthentication: _propTypes2.default.func,
  authenticateUser: _propTypes2.default.func,
  editUserProfile: _propTypes2.default.func,
  logOut: _propTypes2.default.func,
  isDetailsModalOpen: _propTypes2.default.bool,
  openAuthenticationModal: _propTypes2.default.func,
  userAuthentication: _propTypes2.default.object,
  activeFiltersQuantity: _propTypes2.default.number,
  changeActiveFiltersQuantity: _propTypes2.default.func,
  saveRecentSearch: _propTypes2.default.func,
  clearPropertiesList: _propTypes2.default.func,
  findByNeighborhood: _propTypes2.default.func,
  resetNeighborhoodCompany: _propTypes2.default.func,
  companyFindByNeighborhood: _propTypes2.default.object,
  preloadData: _propTypes2.default.object };


var mapStateToProps = function mapStateToProps(state) {return {
    loading: state.propertySearch.loading,
    loaded: state.propertySearch.loaded,
    properties: state.propertySearch.data,
    agenciesLoading: state.agencySearch.loading,
    agenciesLoaded: state.agencySearch.loaded,
    agencies: state.agencySearch.data,
    propertyPins: state.propertyPins.data,
    loadingPins: state.propertyPins.loading,
    citiesData:
    state.cities.data &&
    state.cities.data.map(function (item) {return (
        (0, _pick2.default)(item, ['localisation', 'location', 'property_count', 'id']));}) ||

    [],
    citiesLoading: state.cities.loading || false,
    cityPolygon: state.propertyPins.cityPolygon,
    cityPolygonName: state.propertyPins.cityPolygonName,
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    translateCities: (0, _reduxPagan.getLang)(state.lang, 'citiesDescription'),
    translateProjects: (0, _reduxPagan.getLang)(state.lang, 'projectsDescription'),
    query: state.routing.locationBeforeTransitions.query,
    isLastPage: state.propertySearch.isLastPage,
    companyFindByNeighborhood: state.companyFindByNeighborhood,
    propertyNotes: state.propertyNotes.data,
    submitting: state.mobilesFilters.submitting,
    isMobileFiltersOpen: state.mobilesFilters.isMobileFiltersOpen,
    isAdvancedFiltersOpen: state.advancedFilters.isAdvancedFiltersOpen,
    favoriteProperties: state.favoriteProperties,
    reviewedPins: state.reviewedPins.reviewedIds,
    userAuthentication: state.userAuthentication,
    userToken: state.userAuthentication.data ?
    state.userAuthentication.data.access_token :
    null,
    propertiesCount: state.propertySearch.propertiesCount,
    projectsCount: state.propertySearch.projectsCount,
    skip: state.propertySearch.skip,
    sort: state.propertySearch.sort,
    propertyTypes: state.propertyTypes.sorted || {},
    isDetailsModalOpen: state.propertyDetails.isDetailsModalOpen,
    preloadData: state.propertyDetails.preloadData,
    suppressLoad: state.propertySearch.suppressLoad,
    mobileMapIsVisible: state.propertySearch.mobileMapIsVisible,
    saveSearchLocation: state.saveSearchLocation,
    activeFiltersQuantity: state.propertySearch.activeFiltersQuantity
    // homesQuantity: state.propertySearch.data.length // TODO: Add initial data for loading
  };};

var mapDispatchToProps = {
  searchProperty: _propertySearch.searchProperty,
  searchAgencies: _agencySearch.searchAgencies,
  openDetailsPopup: _propertyDetails.openDetailsPopup,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  loadMore: _propertySearch.loadMore,
  loadPins: _propertyPins.loadPins,
  openMobileFilters: _mobilesFilters.openMobileFilters,
  hideMobileFilters: _mobilesFilters.hideMobileFilters,
  findByNeighborhood: _findByNeighborhood.findByNeighborhood,
  openAdvancedFilters: _advancedFilters.openAdvancedFilters,
  hideAdvancedFilters: _advancedFilters.hideAdvancedFilters,
  addPropertyNote: _propertyNotes.addPropertyNote,
  setPinAsReviewed: _reviewedPins.setPinAsReviewed,
  toggleFavorite: _favoriteProperties.toggleFavorite,
  loadFavorites: _favoriteProperties.loadFavorites,
  saveFavoritesData: _favoriteProperties.saveFavoritesData,
  setFavoritesListState: _favoriteProperties.setFavoritesListState,
  receivePropertiesCount: _propertySearch.receivePropertiesCount,
  receiveProjectsCount: _propertySearch.receiveProjectsCount,
  suppressLoading: _propertySearch.suppressLoading,
  toggleMobileMap: _propertySearch.toggleMobileMap,
  setPreloadData: _propertyDetails.setPreloadData,
  openSaveSearchLocationModal: _saveSearchLocation.openModal,
  closeSaveSearchLocationModal: _saveSearchLocation.closeModal,
  saveSearchData: _saveSearchLocation.saveSearchData,
  socialNetworkAuthentication: _userAuthentication.socialNetworkAuthentication,
  authenticateUser: _userAuthentication.authenticateUser,
  editUserProfile: _userAuthentication.editUserProfile,
  openAuthenticationModal: _userAuthentication.openAuthenticationModal,
  changeActiveFiltersQuantity: _propertySearch.changeActiveFiltersQuantity,
  saveRecentSearch: _recentSearches.saveRecentSearch,
  clearPropertiesList: _propertySearch.clearPropertiesList,
  resetNeighborhoodCompany: _findByNeighborhood.resetNeighborhoodCompany };exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchResultsPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/SearchResultsPage/SearchResultsPage.js
// module id = 3111
// module chunks = 0